<template>
  <div id="home">
    <div class="description">
      <ul>
        <li>UTILIZE</li>
        <li>THE POWER OF</li>
        <li>COLLABORATIVE</li>
        <li>SOCIAL COMMERCE</li>
        <li>
          <button type="button" class="btn-join" @click="onClickPopup()">JOIN FOR FREE</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import JoinPopup from "@/services/JoinForfreePopup.js";
export default {
  name: "home",
  methods: {
    onClickPopup() {
      JoinPopup.open();
    }
  }
};
</script>

<style lang="scss" scoped>
#home {
  background-image: url("../assets/images/background-home.jpg");
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  height: 100vh;

  .description {
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    ul {
      width: 100%;
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        text-align: center;
        color: #fff;
        padding: 0;
        margin: 0;
        line-height: 80px;
        &:nth-child(1) {
          font-size: 56px;
        }

        &:nth-child(2) {
          font-size: 68px;
        }

        &:nth-child(3) {
          font-size: 68px;
        }

        &:nth-child(4) {
          font-size: 80px;
        }

        &:nth-child(5) {
          margin-top: 50px;
          line-height: none;
          button {
            background-color: var(--primary-color);
            height: 72px;
            color: #fff;
            font-size: 28px;
            padding: 0 72px;
            border: none;
          }
        }
      }
    }
  }
}
</style>